import { withInstall } from "../utils/index.mjs";
import _Collapse from "./Collapse.mjs";
const Collapse = withInstall(_Collapse);
var stdin_default = Collapse;
import { collapseProps } from "./Collapse.mjs";
export {
  Collapse,
  collapseProps,
  stdin_default as default
};
